import { useEffect, useState } from 'react';
import { useAuth } from '../../../../context/AuthContext/AuthContext';
import { CertificateResponse } from '../services/get/certificate/models';
import GetCertificatesService from '../services/get/certificate/getCertificate';

export const useCertificates = (anonymous: boolean) => {
  const { tokens } = useAuth();
  const [certificates, setCertificates] = useState<CertificateResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true); // Ajout du state `loading`

  useEffect(() => {
    setLoading(true);
    const fetchCertificates = async () => {
      if (tokens) {
        try {
          const response = await GetCertificatesService.getCertificates(
            tokens.accessToken,
            anonymous,
          );
          setCertificates(response);
        } catch (error) {
          console.error('Failed to fetch certificates', error);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, [tokens, anonymous]);

  return { certificates, loading };
};
